import {models} from '../active_record'
import {normalizeJoinKeys} from './record_keys'

export const getModel = key => {
	const model = models[key]
	return {model, defaultJoins: normalizeJoinKeys(model?.defaultJoins), sort: model?.sort}
}
